<jbm-date-range-input [sm]="true" [from_date]="'10-10-2021'" [to_date]="'10-10-2021'"></jbm-date-range-input>
<input class="form-control form-control-sm" value="Test">
